import { ComponentType } from 'react';

import Delivery from '@/components/SvgIcons/ServicesOverview/Delivery';
import Design from '@/components/SvgIcons/ServicesOverview/Design';
import Development from '@/components/SvgIcons/ServicesOverview/Development';
import Discovery from '@/components/SvgIcons/ServicesOverview/Discovery';

export type ServicesOverviewKey = 'discovery' | 'design' | 'development' | 'delivery';

export interface ServicesOverviewColumn {
  key: ServicesOverviewKey;
  Icon: ComponentType<{ size?: string | number; muted?: boolean }>;
  items: string[];
}

export const servicesOverview: ServicesOverviewColumn[] = [
  {
    key: 'discovery',
    Icon: Discovery,
    items: [
      'discoveryWorkshops',
      'processMapping',
      'productScoping',
      'informationArchitecture',
      'aiStrategy',
      'digitalTransformation',
    ],
  },
  {
    key: 'design',
    Icon: Design,
    items: ['uxResearch', 'uiDesign', 'designSystems', 'prototyping', 'motionAnimation', 'brandIdentity'],
  },
  {
    key: 'development',
    Icon: Development,
    items: ['nextReact', 'javaKotlin', 'restGraphql', 'cloudInfrastructure', 'devOpsCiCd', 'wordpressWebflow'],
  },
  {
    key: 'delivery',
    Icon: Delivery,
    items: ['maintenance', 'scaling', 'monitoring', 'trainingHandover', 'continuousSupport'],
  },
];
